export default __webpack_public_path__ + "img/logo-peruzzi-architecte.83e93ca9.png";